import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var OccTherapy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.867 13.47a6.258 6.258 0 0 0-6.284 6.285c0 3.093 2.294 5.687 5.286 6.186v6.685a9.366 9.366 0 0 1-9.375 9.379 9.366 9.366 0 0 1-9.376-9.38v-7.283c6.184-.299 11.071-5.487 11.071-11.673V2.295a1 1 0 0 0-.997-.998h-3.79C21.002.499 20.304 0 19.407 0c-1.197 0-2.294.998-2.294 2.295s.997 2.295 2.294 2.295c.898 0 1.695-.5 1.995-1.297h2.792v10.376c0 5.388-4.388 9.778-9.774 9.778h-.3c-5.086-.2-9.375-4.49-9.375-9.878V3.193h2.793c.399.798 1.097 1.297 1.995 1.297 1.197 0 2.294-.998 2.294-2.295S10.829 0 9.632 0c-.897 0-1.695.499-1.994 1.297h-3.79a1 1 0 0 0-.998.998v11.374c0 6.086 4.588 10.975 10.473 11.673v7.384C13.323 38.912 18.41 44 24.593 44c6.184 0 11.27-5.088 11.27-11.274V25.94c2.993-.399 5.287-2.993 5.287-6.186a6.258 6.258 0 0 0-6.283-6.286Zm0 7.283c-.5 0-.998-.499-.998-.998a1 1 0 0 1 .998-.998c.598 0 .997.4.997.998a1 1 0 0 1-.997.998Zm.997 3.193v-1.497c1.197-.4 1.995-1.497 1.995-2.794a2.895 2.895 0 0 0-2.893-2.893 2.895 2.895 0 0 0-2.892 2.893c0 1.297.798 2.395 1.995 2.794v1.497c-1.896-.4-3.392-2.195-3.392-4.19 0-2.396 1.995-4.39 4.29-4.39 2.393 0 4.388 1.994 4.388 4.39-.1 2.094-1.596 3.79-3.491 4.19Z"
  }));
});
OccTherapy.displayName = 'OccTherapy';
OccTherapy.defaultProps = {
  'aria-label': 'OccTherapy'
};
export default OccTherapy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/OccTherapy.js
// module id = 3676
// module chunks = 11